import {Error, FloatingLabel, Label} from '@progress/kendo-react-labels';
import {TextAreaProps, InputHandle, TextArea, TextAreaBlurEvent, TextAreaHandle} from "@progress/kendo-react-inputs";
import React, {KeyboardEventHandler, useEffect, useRef, useState} from "react";
import "./FlintTextBox.scss";
import {GUID} from "../../utils/AppConstants";


export default function FlintTextArea(props: FlintTextAreaProps) {
    const [visited, setVisited] = useState(false);
    const inputRef = useRef<TextAreaHandle | null>(null); // Corrected type for Kendo Input ref
    const {validationData, value, ...others} = props;
    const handleBlur = (event: TextAreaBlurEvent) => {
        setVisited(true);
        validationData?.validateFunction?.(validationData?.optionalObjectToValidate).catch((err) => {
        });
        if (props.onBlur) {
            props.onBlur(event); // Call the parent's onBlur handler if provided
        }
    };

    const handleKeyUp = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (props.onEnterPressed && event.key === 'Enter') {
            event.stopPropagation();
            props.onEnterPressed(event); // Call the onEnterPressed handler
        }
        if (props.onKeyUp) {
            props.onKeyUp(event); // Call the parent's onKeyUp handler if provided
        }
    };
    return (
        <div className="flint-field flint-text-area">
            <FloatingLabel editorId={props.id} editorValue={props.value as string} label={props.label}>
                <TextArea
                    {...others}
                    value={value ?? ""}
                    valid={!validationData?.validationMessage}
                    ref={inputRef} // Use the corrected ref
                    onBlur={handleBlur}
                    onKeyUp={handleKeyUp}
                />
            </FloatingLabel>
            {validationData?.validationMessage != null && <Error>{validationData?.validationMessage}</Error>}
        </div>
    );
}

export interface FlintTextAreaProps extends TextAreaProps {
    onEnterPressed?: KeyboardEventHandler;
    label?: string;
    validationData?: {
        validationMessage?: string | undefined,
        validateFunction?: (objectToValidate?: any) => Promise<void>,
        optionalObjectToValidate?: any
    }
}
